import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { Box, IconButton } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";
import CustomToolTipWithPermission from "../../../../../components/CustomToolTipWithPermission";

const AssetCardActionButtons = ({ onEdit, onDelete, hasPermission }) => {
  const colors = useColors();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        zIndex: 10,
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <CustomToolTipWithPermission
        title={"Edit critical asset"}
        permission={hasPermission}
        placement="top"
      >
        <IconButton
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "6px",
            padding: "4px",
            cursor: hasPermission ? "pointer" : "default",
            border: "1px solid " + colors.grey_300,
            "&:hover": {
              backgroundColor: colors.grey_200,
            },
          }}
          onClick={(e) => {
            e.stopPropagation();
            hasPermission && onEdit();
          }}
          size="small"
        >
          <EditRoundedIcon
            sx={{
              color: colors.action_active,
              width: "16px",
              height: "16px",
            }}
          />
        </IconButton>
      </CustomToolTipWithPermission>
      <CustomToolTipWithPermission
        title={"Delete critical asset"}
        permission={hasPermission}
        placement="top"
      >
        <IconButton
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            cursor: hasPermission ? "pointer" : "default",
            borderRadius: "6px",
            padding: "4px",
            border: "1px solid " + colors.grey_300,
            "&:hover": {
              backgroundColor: colors.grey_200,
            },
          }}
          onClick={(e) => {
            e.stopPropagation();
            hasPermission && onDelete();
          }}
          size="small"
        >
          <DeleteRoundedIcon
            sx={{
              color: colors.action_active,
              width: "16px",
              height: "16px",
            }}
          />
        </IconButton>
      </CustomToolTipWithPermission>
    </Box>
  );
};

export default AssetCardActionButtons;
